import { render, staticRenderFns } from "./participateTestAdult.vue?vue&type=template&id=618d9171&scoped=true"
import script from "./participateTestAdult.vue?vue&type=script&lang=js"
export * from "./participateTestAdult.vue?vue&type=script&lang=js"
import style0 from "./participateTestAdult.vue?vue&type=style&index=0&id=618d9171&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d9171",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618d9171')) {
      api.createRecord('618d9171', component.options)
    } else {
      api.reload('618d9171', component.options)
    }
    module.hot.accept("./participateTestAdult.vue?vue&type=template&id=618d9171&scoped=true", function () {
      api.rerender('618d9171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterAdult/participateTestAdult/participateTestAdult.vue"
export default component.exports